import { Link as RouterLink } from '@tanstack/react-router';
import type { ComponentProps, MouseEventHandler } from 'react';
import { backOrExit } from './backOrExit';

export interface LinkProps extends ComponentProps<typeof RouterLink> {
	/**
	 * When true, the link behaves as a back-navigation trigger rather than
	 * performing a normal route change.
	 *
	 */
	back?: boolean | 'exit';
}

/**
 * Wrapper around TanStack Router's `Link` that supports a `back` prop to
 * navigate to the previous *distinct* pathname recorded by our custom
 * navigation utils.
 */
export function Link({ back, onClick, ...rest }: LinkProps) {
	const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
		onClick?.(event);
		if (event.defaultPrevented) return;

		if (back) {
			if (backOrExit(back)) {
				// prevent default navigation so that RouterLink doesn't navigate to provided href or `to` prop
				event.preventDefault();
			}
		}
	};

	return <RouterLink onClick={handleClick} {...rest} />;
}
